import { Validator } from '@vueform/vueform/src/core.js'

const testrule = class extends Validator {
  check(value) {
    return false;
  }
  get msg() {
    return 'The test rule blocks submit';
  }
}

const adsphone = class extends Validator {
  check(value) {
    return /^\+?[0-9\s\-\.\(\)]{7,20}$/.test(value)
  }
  get msg() {
    return 'The :attribute field must be a valid phone number.';
  }
}

const adsfirstname = class extends Validator {
  check(value) {
    return /^[A-Za-zÀ-ÿ][A-Za-zÀ-ÿ'-]*(?: [A-Za-zÀ-ÿ][A-Za-zÀ-ÿ'-]*)*$/.test(value)
  }
  get msg() {
    return 'The :attribute field has invalid characters.';
  }
}

const adslastname = class extends Validator {
  check(value) {
    return /^[A-Za-zÀ-ÿ][A-Za-zÀ-ÿ'.,-]*(?: [A-Za-zÀ-ÿ][A-Za-zÀ-ÿ'.,-]*)*$/.test(value)
  }
  get msg() {
    return 'The :attribute field has invalid characters.';
  }
}

export default {
  testrule,
  adsphone,
  adsfirstname,
  adslastname,
}
